import { render, staticRenderFns } from "./ukeyRecipientInfo.vue?vue&type=template&id=6195fa23&scoped=true"
import script from "./ukeyRecipientInfo.vue?vue&type=script&lang=js"
export * from "./ukeyRecipientInfo.vue?vue&type=script&lang=js"
import style0 from "./ukeyRecipientInfo.vue?vue&type=style&index=0&id=6195fa23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6195fa23",
  null
  
)

export default component.exports